const corporateInfoHeadTitleList: any[] = [
  {
    headTitle: "経営者種別",
  },
  {
    headTitle: "法人番号: 法人名",
  },
  {
    headTitle: "代表者職名",
  },
  {
    headTitle: "代表者氏名",
  },
  {
    headTitle: "住所",
  },
  {
    headTitle: "代表連絡方法",
  },
  {
    headTitle: "履歴事項全部証明書",
  },
  {
    headTitle: "就業規則",
  },
  {
    headTitle: "給与規程",
  },
];

const facilityInfoHeadTitleList: any[] = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "施設区分",
  },
  {
    headTitle: "入所定員（利用定員）",
  },
  {
    headTitle: "職員配置基準数",
  },
  {
    headTitle: "申込時職員総数",
  },
  {
    headTitle: "加入職員数",
  },
  {
    headTitle: "雇用期間1年未満職員数",
  },
  {
    headTitle: "労働時間2/3未満職員数",
  },
  {
    headTitle: "当該施設・事業を経営している証拠書類",
  },
];

const contextText =
  "続けて「俸給の調整額」対象手当の登録が必要です。<このまま登録しますか、契約完了後に登録しますか。";

const stepperData = [
  "法人情報",
  "施設情報・職員情報",
  "届出内容確認",
  "機構へ提出",
];
export {
  corporateInfoHeadTitleList,
  facilityInfoHeadTitleList,
  contextText,
  stepperData,
};
